import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import CheckboxOption from "csi/middleware/customView/options/CheckboxOption";
import { isDefined } from "csi/utility/coreUtility";
import { Button, GridColumn, GridRow, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import CustomViewCalculationItem from "./CustomViewCalculationItem";
import { useCustomViewReportStore } from "./CustomViewReportStore";

const CustomViewReportPane: FunctionComponent = observer((props) => {
	const {
		addCalculationItem,
		calculationList,
		hideNestedReports,
		isDisabled,
		setHideNestedReports,
	} = useCustomViewReportStore();

	return (
		<Accordion data-csi-automation="CustomViewReportPane">
			<AccordionSummary>
				<Text res="CustomViewReportPane" semiBold />
			</AccordionSummary>
			<AccordionDetails>
				<GridColumn>
					{calculationList.map((level, index) => (
						<CustomViewCalculationItem
							index={index}
							key={`calculationItem-${index}`}
						/>
					))}
					<GridRow 
						data-csi-automation="CustomViewReportPaneButtons"
						spacingAroundY={1}
					>
						<Button
							design="outline"
							disabled={isDisabled}
							onClick={addCalculationItem}
							res="CustomViewAddCalculationItem"
						/>
					</GridRow>
					{isDefined(hideNestedReports) && (calculationList.length > 0) && (
						<GridRow spacingAroundY={2}>
							<CheckboxOption
								label="CustomViewHideNestedCalculations"
								onChange={setHideNestedReports}
								optionValue={hideNestedReports}
								paddingBottom={0}
								paddingLeft={0}
							/>
						</GridRow>
					)}
				</GridColumn>
			</AccordionDetails>
		</Accordion>
	);
});

export default CustomViewReportPane;